<template>
  <div class="mb-2 w-full md:w-134 md:mx-auto input">
    <div class="flex relative">
      <slot />
      <label
        v-if="!value"
        :class="themeIsDark ? 'text-gray-200' : 'text-gray-300 '"
        class="absolute left-6 top-6 leading-none text-base"
        >{{ placeholder }}</label
      >
      <select
        :name="name"
        @change="onChange"
        :class="
          themeIsDark
            ? 'bg-transparent border-white placeholder-white focus:shadow-none focus:ring-transparent focus:border-white'
            : 'bg-white border-gray-300  focus:shadow-none focus:ring-transparent focus:border-gray-300 '
        "
        class="
          border
          rounded-md
          block
          w-full
          py-5
          px-6
          text-base
          leading-tight
          focus:outline-none
               "
        :value="value"
      >
        <option hidden></option>
        <option
          v-for="(option, index) in options"
          :key="index"
          :value="option.id"
          class="text-black"
        >
          {{ option.label }}
        </option>
      </select>
    </div>
    <div
      v-if="hint && hintState === 'error'"
      :class="hintTextColor[hintState]"
      class="flex text-xs mt-px mb-2 text-left items-center hint"
    >
      <!-- <Icon v-if="hintState == 'success'" id="inputSuccess" class="inline" /> -->
      <!-- <Icon v-if="hintState == 'error'" id="inputError" class="inline" /> -->
      <span class="">{{ hint }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

@Component({
  components: {
  }
})
export default class InputSelect extends Vue {
  @Prop({ default: 'default' }) hintState!: 'error' | 'default' | 'success'
  @Prop() placeholder!: string
  @Prop() hint!: string
  @Prop() options!: { label: string, id: string }[]
  @Prop() value!: string
  @Prop() name!: string

  @Getter themeIsDark!: boolean

  onChange (e: { target: { value: string } }) {
    const val = e.target.value

    this.$emit('input', val)
  }

  hintTextColor = {
    error: 'text-red-500',
    success: 'text-green-500'
  }
}
</script>
